import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack } from "@atlaskit/primitives";
import { JiraServiceManagementIcon } from "@atlaskit/logo";
import { boxStyles } from "./utils/wizardstyles";
import {setWizardCategory}  from "../redux/actions/wizardActions"
const WizardCategoryItem = ({category}) => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(setWizardCategory(category.id))
  };
  return (
    <Box xcss={boxStyles} as="li" onClick={onClick}>
      <JiraServiceManagementIcon />
      {category.title}
      <Stack space="space.100">
        <Box as="span">{category.description}</Box>
      </Stack>
    </Box>
  );
};
export default WizardCategoryItem;
